module.exports = __webpack_public_path__ + "img/1.177a5ed2.jpg";